module.exports = __webpack_public_path__ + "media/images/index-hero-badge-th-dc3482eb81f54c5997e192ced0767590.svg";